import { ASSISTANT_API_URL } from '../../../config/env';
import { fetchWithAnswersAuth } from '../../../api/auth';

/** Central registry of Assistants HTTP endpoints. */
export const AssistantsEndpoints = {
  AGENTS: `${ASSISTANT_API_URL}/agents`,
  COMPETITORS: `${ASSISTANT_API_URL}/competitors`,
  REFERENCE_URL_SCOPES: `${ASSISTANT_API_URL}/reference-urls/scopes`,
  CHAT_STREAM: `${ASSISTANT_API_URL}/chat/stream`,
  CURATED_CHAT_STREAM: `${ASSISTANT_API_URL}/curated-chat/stream`,
};

/**
 * Authenticated fetch for Assistants APIs.
 * @param {string} url
 * @param {RequestInit} [init]
 * @returns {Promise<Response>}
 */
export async function assistantsFetch(url, init = {}) {
  return fetchWithAnswersAuth(url, init);
}

/**
 * JSON request with standard Assistants error handling.
 * @param {string} url
 * @param {RequestInit} [init]
 */
export async function assistantsFetchJson(url, init = {}) {
  const response = await assistantsFetch(url, init);
  if (!response.ok) {
    const err = await response.json().catch(() => ({ detail: response.statusText }));
    throw new Error(err.detail || response.statusText || `Request failed: ${response.status}`);
  }
  return response.json();
}
